import { toFirstLowerCase, toFirstUpperCase } from 'infrastructure/functions';

import { deleteUnnecessaryEmptyLines } from '../helpers';

type TData = {
  hasQuestions: any;
  questions: any;
  reminderTakeReadingsRegularly: any;
  reminderMonitorHealthConditions: any;
  needConsumables: any;
  verifiedAddress: [];
  transferCallToNursingTeam: any;
  additionalDetails: any;
  whichPerson: string;
  otherPerson: string;
  goalToUseDevice: any;
  goalToUseDeviceOther: any;
};

export const generateWrapUpMessage = <T extends TData>(data: T) => {
  const {
    hasQuestions,
    questions = '',
    reminderTakeReadingsRegularly,
    reminderMonitorHealthConditions,
    needConsumables,
    verifiedAddress,
    transferCallToNursingTeam,
    additionalDetails = '',
    whichPerson,
    otherPerson,
    goalToUseDevice,
    goalToUseDeviceOther,
  } = data;
  let message = '';

  const isPatient = whichPerson === 'Patient';
  const target =
    whichPerson === 'Other'
      ? toFirstLowerCase(otherPerson as string)
      : toFirstLowerCase(whichPerson as string);

  const speakWith = isPatient ? 'patient' : `${target}`;

  const speakWithUpperCase = isPatient
    ? 'Patient'
    : `${toFirstUpperCase(target)}`;

  if (hasQuestions === 'yes') {
    message += `${speakWithUpperCase} reported other concerns they would like to discuss with MA today. `;
    message += '\n';
    message += '\n';
    if (questions) {
      message += `${questions} `;
      message += '\n';
      message += '\n';
    }
  }
  if (hasQuestions === 'no') {
    message += `${speakWithUpperCase} denies any other concerns today. `;
    message += '\n';
    message += '\n';
    if (questions) {
      message += `${questions} `;
      message += '\n';
      message += '\n';
    }
  }
  if (
    reminderTakeReadingsRegularly.length > 0 ||
    reminderMonitorHealthConditions.length > 0
  ) {
    message += `MA encouraged ${speakWith} to continue taking ${
      isPatient ? 'their' : "patient's"
    } readings regularly. `;
    message += '\n';
    message += '\n';
  }
  if (reminderTakeReadingsRegularly.length > 0 && goalToUseDevice) {
    if (goalToUseDevice === 'Other') {
      message += `${speakWithUpperCase} set a goal to use device ${goalToUseDeviceOther}. `;
    }
    if (goalToUseDevice !== 'Other') {
      message += `${speakWithUpperCase} set a goal to use device ${goalToUseDevice}. `;
    }
  }

  if (needConsumables === 'yes') {
    message += `${speakWithUpperCase} confirms needing supplies. `;
    if (verifiedAddress.length > 0) {
      message += `MA verified address, supplies ordered. `;
    }
    message += '\n';
    message += '\n';
  }
  if (needConsumables === 'no') {
    message += `${speakWithUpperCase} denies needing supplies. `;
    message += '\n';
    message += '\n';
  }
  if (transferCallToNursingTeam.length > 0) {
    message += `MA transferred call to the nursing team. `;
    if (additionalDetails) {
      message += '\n';
      message += '\n';
    }
  }
  if (additionalDetails) {
    message += `${additionalDetails} `;
  }

  message = deleteUnnecessaryEmptyLines(message);
  return message;
};
